enum MainMenu {
  DASHBOARD = 'DASHBOARD',
  BASE_DATA = 'BASE_DATA',
  ANALYTICS = 'ANALYTICS',
  ROSTER = 'ROSTER',
  ADMINISTRATION = 'ADMINISTRATION',
  CONFIGURATION = 'CONFIGURATION',
  PLANNING = 'PLANNING',
  INDICATORS = 'INDICATORS',
  INVOICING = 'INVOICING',
}

export default MainMenu;
